export const graphColors = {
    blue: '#2760FF',
    black: '#000000',
    lightGrey: '#7A808D',
};
